export const joinSecondary =
  (array: (string | undefined)[], separator: string = ', ') => array.filter(Boolean).join(separator);
